module.exports = __webpack_public_path__ + "images/3aac6ee0efa8365ae559be61f40ece64-bg.jpg";